import React from 'react'

const RenderHeaderCard = ({ children }: any) => {
  return (
    <div className="col-md-12">
      <div className="card p-4" style={{ borderRadius: "0 0 4px 4px"}}>
          {children}
        </div>
      </div>
  )
}

export default RenderHeaderCard